import { render, staticRenderFns } from "./MenuItemMob.vue?vue&type=template&id=562fc0ae&scoped=true&"
import script from "./MenuItemMob.vue?vue&type=script&lang=js&"
export * from "./MenuItemMob.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemMob.vue?vue&type=style&index=0&id=562fc0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562fc0ae",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuItemMob.vue
// module id = 142
// module chunks = 0